<template>
  <div class="component-container loud-speaker-list">
    <div class="container-head contain-btn-title">
      <div class="paper-head-title">
        <i class="icon-icon_xiaolian iconfont"></i>
        <span class="paper-tabal">社会任职</span>
        <span class="paper-text"> > 证件 > 自留地 </span>
        <common-button style="float: right" size="default" type="cancel" image @click="back()">返回</common-button>
      </div>
    </div>

    <div class="container-body">
      <div class="form-heard">
        <el-form label-width="70px" style="margin-bottom: 20px">
          <div class="AchievementList-list-body-main-fastener">
            <button type="button" style="float: left;background-color: rgb(13 144 246);font-size: 15px;" class=" AchievementList-list-body-main-button icon-icon_wenjianjia iconfont " @click="openFile">&nbsp;&nbsp;新建文件夹</button>
            <button type="button" class=" AchievementList-list-body-main-button-down icon-daochu iconfont " @click="importFile">导入</button>
            <button type="button" class=" AchievementList-list-body-main-button-down icon-xiazai iconfont " @click="download">下载</button>
            <div class="pending-items-search" style="text-align: left;">
              <input placeholder="搜索" class="input-catch"></input>
              <i class="iconfont icon-sousuo" @click="catchFilw" type="button"></i>
            </div>
          </div>
        </el-form>
      </div>
      <div class="form-body">
        <div class="photo-item-panel">
          <span style="font-weight: bold;font-size: 18px; display: block">2022/10/27</span>
          <div class="photo-item-outside">
            <div class="photo-item-up">
              <div class="photo-item-img-outside ">
                <div class="photo-item-i">
                  <i class=" iconfont icon-wenjianjia " style="color: #FFD15C;font-size: 180px;"></i>
                </div>
              </div>
              <span class="photo-item-text">文件夹</span>
            </div>
          </div>
          <div class="photo-item-outside">
            <div class="photo-item-up">
              <div class="photo-item-img-outside ">
                <div class="photo-item-i">
                  <i class=" iconfont icon-wenjianjia " style="font-size: 180px;color: #FFD15C;"></i>
                </div>
              </div>
              <span class="photo-item-text">文件夹</span>
            </div>
          </div>
          <div class="photo-item-outside">
            <div class="photo-item-up">
              <div class="photo-item-img-outside ">
                <div class="photo-item-i">
                  <i class=" iconfont icon-wenjianjia " style="font-size: 180px;color: #FFD15C;"></i>
                </div>
              </div>
              <span class="photo-item-text">文件夹</span>
            </div>
          </div>

          <div class="photo-item-outside">
            <div class="photo-item-up">
              <div class="photo-item-img-outside"> <img src="static/images/login_banner.jpg" /></div>
              <span class="photo-item-text">文件名文件名文件名</span>
            </div>
          </div>

          <div class="photo-item-outside">
            <div class="photo-item-up">
              <div class="photo-item-img-outside"> <img src="static/images/login_banner.jpg" /></div>
              <span class="photo-item-text">文件名文件名文件名</span>
            </div>
          </div>
          <span style="font-weight: bold;font-size: 18px; display: block">2022/10/26</span>
          <div class="photo-item-outside">
            <div class="photo-item-up">
              <div class="photo-item-img-outside"> <img src="static/images/login_banner.jpg" /></div>
              <span class="photo-item-text">文件名文件名文件名</span>
            </div>
          </div>
          <div class="photo-item-outside">
            <div class="photo-item-up">
              <div class="photo-item-img-outside"> <img src="static/images/login_banner.jpg" /></div>
              <span class="photo-item-text">文件名文件名文件名</span>
            </div>
          </div>
          <div class="photo-item-outside">
            <div class="photo-item-up">
              <div class="photo-item-img-outside"> <img src="static/images/login_banner.jpg" /></div>
              <span class="photo-item-text">文件名文件名文件名</span>
            </div>
          </div>

        </div>
      </div>
    </div>
<!--    <animation :loadingDataVisible="(!attachmentUploadState || !formInfoSaveState) || data.isLoading" :loadingText="loadingText"></animation>
    &lt;!&ndash;      <div class="case-share-list-foot"></div>&ndash;&gt;

    <LoudSpeakerDetail :edit-flag="dialog.editFlag" v-if="dialog.isShow" @closeDialog="closeDialog"/>-->
  </div>
</template>

<script>
    export default {
        name: "ServiceList",
      data(){
          return{
            this_:this,//保存this以便filters中使用
            //true是结束,false是正在处理
            attachmentUploadState:true,
            //true是结束,false是正在处理
            formInfoSaveState:true,
            loadingText:null,
            data:{
              isLoading:false,
              pageNum: 1,
              pageSize: 9,
              total: 9,
              currentPage: 1
            },
            LoudSpeakerData:[],
            dialog:{
              isShow: false,
              caseId:null,
              editFlag:'view',
            }

          }
      },
      // filters:{
      //   //取截单元,单位
      //   fileSizeUnit:(arg)=> {
      //     if (parseFloat(arg)/(1024*1024) > 1){
      //       return (parseFloat(arg)/(1024*1024)).toFixed(2) + 'M'
      //     }else if (parseFloat(arg)/(1024) > 1) {
      //       return (parseFloat(arg)/(1024)).toFixed(2) + 'K'
      //     }else {
      //       return arg + 'B';
      //     }
      //   },
      //   fileIcon:function (arg,this_) {
      //     if (arg.length>0){
      //       let type= arg[0].attachmentOriginalName.substring(arg[0].attachmentOriginalName.lastIndexOf('.') + 1)
      //       return (this_.fileIconType[type]+' iconfont')
      //     }
      //     return '';
      //   }
      // },
      methods:{
        back(){
          this.$router.push({path: '/certificate/CertificateList'})
        },
        // 新建按钮
        openFile(){
        },
        importFile(){

        },
        download(){
        },
        //查询
        catchFilw(){

        },
        closeDialog(){

        },
      }
    }
</script>

<style scoped>
.loud-speaker-list{
  margin: 20px;
}
.paper-tabal{
  margin-top: 2px;
  position: absolute;
  padding-left: 10px;
  font-family: SourceHanSansSC;
  font-weight: 700;
  font-size: 24px;
  color: rgb(8, 39, 44);
  font-style: normal;
  letter-spacing: 0px;
  line-height: 20px;
  text-decoration: none;
}
.paper-text{
  margin-top: 7px;
  position: absolute;
  margin-left: 120px;
  border: none;
  /* padding-left: 5px; */
  font-family: SourceHanSansSC;
  font-weight: 400;
  font-size: 18px;
  color: rgb(8, 39, 44);
  font-style: normal;
  letter-spacing: 0px;
  line-height: 20px;
  text-decoration: none;
}
/deep/ .el-table .cell{
  line-height: unset;
}
i.icon-wenjianjia{
  color: #f09f19;
  font-size: 40px;
}
i.icon-PDF{
  color: #eb5e5e;
  font-size: 40px;
}
i.icon-file-excel-fill{
  color: #00c090;
  font-size: 40px;
}
i.icon-file-ppt-fill{
  color: #ff7082;
  font-size: 40px;
}
.AchievementList-list-body-main-button {
  border:  none;
  color: rgb(241 247 255);
  outline: none;
  border-radius: 3px;
  width: 120px;
  height: 35px;
  text-align: center;
  background-image: url('/static/images/fourbackground.png');
}
.AchievementList-list-body-main-button-down{
  /*font-weight: bold;*/
  float: left;
  border: 1px solid rgb(132 198 252);
  margin-left: 10px;
  background-color: rgb(248 251 255);
  /* font-size: 15px; */
  /* border: none; */
  color: rgb(140 147 250);
  outline: none;
  border-radius: 3px;
  width: 85px;
  height: 35px;
  text-align: center;
  background-image: url(/static/images/fourbackground.png);
}
i.icon-daochu{
  color: rgb(52, 197, 231);;
  font-size: 18px;
}
i.icon-icon_wenjianjia{
  color: rgb(52, 197, 231);;
  font-size: 18px;
}
.icon-xiazai:before{
  font-size: 20px;
  margin-right: 8px;
}
.icon-daochu:before{
  font-size: 20px;
  margin-right: 8px;
}
.pending-items-search input{
  /*padding-left: 10px;*/
  width: 330px;
  margin-left: 10px;
  height: 35px;
  /* border-style: none; */
  /* align-items: inherit; */
  /* border-color: unset; */
  /* border-radius: 15px; */
  /* font-size: 14px; */
  /* font-weight: normal; */
  /* font-style: normal; */
  /*background: rgb(238, 244, 251);*/
  /*!* outline-color: #caecf5;*/

}
i.icon-sousuo{
  margin-left: -35px;
  color:#d3d4d5;
}
.input-catch{
  -webkit-appearance: none;
  background-color: #FFF;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  /* height: 40px; */
  line-height: 40px;
  outline: 0;
  padding: 0 15px;
  transition: border-color .2s cubic-bezier(.645,.045,.355,1);

}
.paper-head-title button{
  border: 1px solid rgb(132 198 252);
  border-radius: 3px;
  width: 80px;
  background-color: rgb(248 251 255);
  height: 40px;
  text-align: center;
  background-image: url(/static/images/fourbackground.png);
}
.back-paper-button{
  color: rgb(140 147 250);
  font-weight: bold;
  float: right;
  outline: none;
}
.photo-item-panel{
  text-align: left;
  padding: 20px;

}
.photo-item-outside{
  width: 230px;
  height: 250px;
  /*border: 1px solid black;*/
  margin-top: 20px;
  margin-left: 20px;
  border-radius: 8px;
  display: inline-block;
  /*border: 2px  solid #EDF4FB;*/
}
.photo-item-up{
  width: 200px;
  height: 300px;
  /*border: 1px solid black;*/
  margin-left: 50px;
  margin-bottom: 50px;
  text-align: center;

}
.photo-item-up img{
  width: 180px;
  height: 180px;
  border-radius:10px;
  /*-moz-box-shadow:2px 2px 10px red;*/
  /*-webkit-box-shadow:2px 2px 10px red ;*/
  /*box-shadow:2px 2px 10px red;*/
  /*padding-top: 10px;*/
  /*margin-left: 50px;*/
  /*margin-bottom: 50px;*/
}
.photo-item-img-outside{
  width: 200px;
  height: 200px;
  border-radius:10px;
  background-color: rgb(237,244,251);
  border: 2px solid rgb(237,244,251) ;
  padding-top: 10px;
  margin-bottom: 10px;
}
.photo-item-text{
  font-size: 14px;
}
i.icon-icon_xiaolian{
  font-size: 22px;
  color: rgb(254 93 119);
}
</style>



// WEBPACK FOOTER //
// src/pages/certificate/ServiceList.vue